// test2082
(2082 && 0);
